import React from 'react';
import Modal from './Modal';

export default function TermsModal({ onClose }) {
  return (
    <Modal title="📜 Terms & Conditions" onClose={onClose}>
      <div style={{ maxHeight: '55vh', overflowY: 'auto', color: '#aaa', fontSize: '0.88rem', lineHeight: '1.8' }}>

        <p><strong style={{ color: '#FFD93D' }}>1. Usage</strong><br />
          Resource Rush is a browser-based educational game. No download required.
        </p><br />

        <p><strong style={{ color: '#FFD93D' }}>2. Player Data</strong><br />
          Your username and scores are stored locally in your browser.
          No data is sent to any external server.
        </p><br />

        <p><strong style={{ color: '#FFD93D' }}>3. Privacy</strong><br />
          We collect no personal information. Your profile stays on your device.
        </p><br />

        <p><strong style={{ color: '#FFD93D' }}>4. Fair Play</strong><br />
          Modifying the game code to gain unfair advantages is discouraged.
        </p><br />

        <p><strong style={{ color: '#FFD93D' }}>5. Age</strong><br />
          This game is suitable for all ages. Parental guidance for children under 6.
        </p><br />

        <p><strong style={{ color: '#FFD93D' }}>6. Disclaimer</strong><br />
          The game is provided "as is" for entertainment and educational purposes only.
        </p><br />

        <p style={{ color: '#555', fontSize: '0.8rem' }}>Last updated: March 2026</p>
      </div>
    </Modal>
  );
}